import { z } from "zod";

export const rawStringArraySchema = z.object({ raw: z.string().array() });
